module.exports = __webpack_public_path__ + "img/teacher.825903bd.png";